import { Link, useLocation } from 'react-router-dom'

function Breadcrumbs(props) {
  const location = useLocation();
  if (location !== "/" && props.linklevel == 3) {
    return (
        <div className="container">
            <nav>
                <Link to="/"
                    className={location.pathname === "/" ? "breadcrumb-active" : "breadcrumb-not-active"}
                >
                    Home
                </Link>
                <span className="breadcrumb-arrow">&gt;</span>
                <Link to={"/" + props.linktoone }
                    className={location.pathname.startsWith("/" + props.linktoone) ? "breadcrumb-active" : "breadcrumb-not-active"}
                >
                    {props.linknameone}
                </Link>
                <span className="breadcrumb-arrow">&gt;</span>
                <Link to={"/" + props.linktotwo }
                    className={location.pathname.startsWith("/" + props.linktotwo) ? "breadcrumb-active" : "breadcrumb-not-active"}
                >
                    {props.linknametwo}
                </Link>
                <span className="breadcrumb-arrow">&gt;</span>
                <Link to={"/" + props.linkto }
                    className={location.pathname.startsWith("/" + props.linkto) ? "breadcrumb-active" : "breadcrumb-not-active"}
                >
                    {props.linkname}
                </Link>
            </nav>
        </div>
      );
  }
  if (location !== "/" && props.linklevel == 2) {
    return (
        <div className="container">
            <nav>
                <Link to="/"
                    className={location.pathname === "/" ? "breadcrumb-active" : "breadcrumb-not-active"}
                >
                    Home
                </Link>
                <span className="breadcrumb-arrow">&gt;</span>
                <Link to={"/" + props.linktoone }
                    className={location.pathname.startsWith("/" + props.linktoone) ? "breadcrumb-active" : "breadcrumb-not-active"}
                >
                    {props.linknameone}
                </Link>
                <span className="breadcrumb-arrow">&gt;</span>
                <Link to={"/" + props.linkto }
                    className={location.pathname.startsWith("/" + props.linkto) ? "breadcrumb-active" : "breadcrumb-not-active"}
                >
                    {props.linkname}
                </Link>
            </nav>
        </div>
      );
  }
  if (location !== "/" && props.linklevel == 1) {
    return (
        <div className="container" style={{ padding: '10px'}}>
            <nav>
                <Link to="/"
                    className={location.pathname === "/" ? "breadcrumb-active" : "breadcrumb-not-active"}
                >
                    Home
                </Link>
                <span className="breadcrumb-arrow">&gt;</span>
                <Link to={"/" + props.linkto }
                    className={location.pathname.startsWith("/" + props.linkto) ? "breadcrumb-active" : "breadcrumb-not-active"}
                >
                    {props.linkname}
                </Link>
            </nav>
        </div>
      );
  }

    <div className="container">
        <nav style={{ display: 'none' }}></nav>
    </div>
  
}

export default Breadcrumbs;